module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "timeline-bloc"
  }, [_c('div', {
    staticClass: "timeline-title"
  }, [_vm._v(_vm._s(_vm.$t("orders.timeline.title")))]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-steps"
  }, [_c('span', {
    staticClass: "roundedIcon active"
  }, [_c('i', {
    staticClass: "fas fa-list-alt fa-2x"
  })]), _vm._v(" "), _c('span', {
    staticClass: "roundedIcon"
  }, [_c('i', {
    staticClass: "fas fa-file-invoice-dollar fa-2x"
  })]), _vm._v(" "), _c('span', {
    staticClass: "roundedIcon"
  }, [_c('i', {
    staticClass: "fas fa-check fa-2x"
  })]), _vm._v(" "), _c('span', {
    staticClass: "roundedIcon"
  }, [_c('i', {
    staticClass: "fas fa-shipping-fast fa-2x"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-095e0719","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/OrderMain/Timeline.vue
// module id = 2999
// module chunks = 0